import { Course } from "../model/course";
import { Module, ModuleInput } from "../model/module";
import { v4 as uuidv4 } from 'uuid';

export const uuidGenerator = (course: Course): [Course, boolean] => {

    let input: Course = { ...course };

    if (input.uuid == undefined || input.uuid == "") {
        input.uuid = uuidv4().toString()
    }

    let i = 0

    for (let session of input.sessions) {
        
        for (let j = 0; j < session.contentModules.length; j++) {
            let module = session.contentModules[j];
        
            if (module.uuid == undefined || module.uuid == "") {
                const updatedModule = { ...module, uuid: uuidv4().toString() };
            
                const updatedModulesArray = [...session.contentModules];
                updatedModulesArray[j] = updatedModule;
            
                session = { ...session, contentModules: updatedModulesArray };
            }
        }


        if (session.uuid == undefined || session.uuid == "") {
            session = { ...session, uuid: uuidv4().toString() };
        }

        const updatedSessions = [...input.sessions]
        updatedSessions[i] = session

        input = { ...input, sessions: updatedSessions };
        i++;
    }

    // TODO: spread operator won't do here -> let output: Course = { ...input };
    let output: Course = JSON.parse(JSON.stringify(input))

    return [output, true]
}